<section>
  <div *ngIf="items" class="menu-items">
    <div
      *ngFor="let item of items; trackBy: trackBy"
      [ngClass]="{'active': isActiveRoute(item, currentUrl)}"
      [class.compact]="compact"
      class="menu-item"
    >
      <div
        *ngIf="item.href !== '/admin'"
        class="user-select-none"
        [routerLink]="item.href"
        [joyrideStep]="item.name"
        [title]="guiderService.getGuidTitle(item.name)"
        [text]="guiderService.getGuidText(item.name)"
        (click)="itemClick.emit(item)"
        stepPosition="right"
      >
        <tr-icon
          [icon]="item.icon"
          [size]="size.large"
          [color]="isActiveRoute(item, currentUrl) ? color.green : undefined"
          classes="user-select-none"
        ></tr-icon>
        <p>{{ item.name }}</p>
      </div>

      <span
        *ngIf="item.badgeRouteId"
        class="countbadge"
      ><h4>{{ routeData[item.badgeRouteId]?.badgeCount }}</h4></span>

      <div
        *ngIf="item.href === '/admin'"
        class="user-select-none"
        [joyrideStep]="item.name"
        [title]="guiderService.getGuidTitle(item.name)"
        [text]="guiderService.getGuidText(item.name)"
        stepPosition="right"
        (click)="goToAdmin()"
      >
        <tr-icon
          [icon]="item.icon"
          [size]="size.large"
          [color]="isActiveRoute(item, currentUrl) ? color.green : undefined"
          classes="user-select-none"
        ></tr-icon>
        <p>{{ item.name }}</p>
      </div>
    </div>

    <div class="bottom-links" [class.compact]="compact">
      <div
        *ngIf="showProfileBtn"
        [class.compact]="compact"
        [ngClass]="{'active': isActiveRoute(profileRoute, currentUrl)}"
        class="menu-item"
      >
        <div
          class="user-select-none"
          routerLink="/profile"
          angularticsCategory="auth"
          angulartics2On="click"
          angularticsAction="Profile"
          (click)="itemClick.emit(profileRoute)"
        >
          <span [class.profile-icon]="compact">
            <tr-icon
              [icon]="profileRoute.icon"
              [size]="size.large"
              classes="user-select-none"
              [color]="isActiveRoute(profileRoute, currentUrl) ? color.green : undefined"
            ></tr-icon>
          </span>
          <p>{{ profileRoute.name }}</p>
        </div>
      </div>

      <div *ngIf="(!isNative && windowBeacon) || isNative" [class.compact]="compact" class="menu-item btn-help">
        <div class="user-select-none" (click)="openBeacon()">
          <span [class.profile-icon]="compact">
            <tr-icon
              [icon]="icon.question"
              [size]="size.large"
            ></tr-icon>
          </span>
          <p>Support</p>
        </div>
      </div>

      <div *ngIf="showLogoutBtn" [class.compact]="compact" class="menu-item">
        <div class="user-select-none" (click)="logoutUser()"
           angularticsCategory="auth" angulartics2On="click" angularticsAction="Logout">
          <tr-icon [icon]="icon.logout" [size]="size.large" classes="user-select-none"></tr-icon>
          <p>Logout</p>
        </div>
      </div>
    </div>
  </div>
</section>
